import { useState, useEffect, useRef } from 'react';
import styles from './styles/why-choose-us.module.css'

import { logWhyChooseUsView } from "../../../helpers/google-analytics/gaEvents";

const WhyChooseUs = () => {
  const reasons = [
    {
      title: 'Expertise',
      desc: '30+ years of cabinetry experience',
      extra: 'A family-run business for over 30 years, 1 Stop Kitchens & Countertops is a one-stop-shop for all your kitchen needs! Owned by a licensed cabinet maker, 1 Stop Kitchens and Countertops brings more than 30 years of industry knowledge and expertise to every job they deliver, ensuring you always receive top quality products and service.'
    },
    {
      title: 'Custom & Local',
      desc: 'We proudly use NB-made products',
      extra: 'Servicing Fredericton, NB and surrounding areas, 1 Stop builds, supplies and installs custom and factory-made kitchen and bathroom cabinets, countertops and hardware. We offer laminate and quartz countertops and are proud to be your exclusive supplier of locally made TRIANGLE Kitchen Cabinets from Moncton, NB.'
    },
    {
      title: 'Customer Focused',
      desc: 'We listen and build to your needs',
      extra: 'Our friendly staff takes pride in pleasing our customers and fulfilling their dreams for their home. Through 20-20 technology we are able to turn your dream kitchens into a reality while at the same time providing quality craftsmanship at an affordable price!'
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [lastHoveredIndex, setLastHoveredIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    handleResize(); // initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    logWhyChooseUsView();
  }, [hoveredIndex, activeIndex]);

  const itemRefs = useRef([]);
  itemRefs.current = [];
  const addItemRef = (el) => {
    if (el && !itemRefs.current.includes(el)) {
      itemRefs.current.push(el);
    }
  }

  const handleClick = (index) => {
    if (!isMobile) return;

    const newIndex = activeIndex === index ? null : index;
    setActiveIndex(newIndex);

    // Scroll to the clicked item itself
    setTimeout(() => {
      const targetItem = itemRefs.current[newIndex];
      if (newIndex !== null && targetItem) {
        const headerOffset = 80; // adjust as needed
        const itemPosition = targetItem.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = itemPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 50); // delay for DOM updates
  };

  return (
    <section
      className={`${styles.whyChooseUs} ${hoveredIndex !== null ? styles.active : ''}`}
      onMouseLeave={() => setHoveredIndex(null)}
    >
      <h2>Why Choose Us</h2>
      {!isMobile ? (
        <p className={styles.hoverHint}>Hover over each block to learn more</p>
      ) : (
        <p className={styles.hoverHint}>Select a block to learn more</p>
      )}

      <div className={styles.whyChooseGrid}>
        {reasons.map((r, i) => (
          <div key={i}>
            <div
              className={styles.whyChooseItem}
              onMouseEnter={() => !isMobile && (setLastHoveredIndex(hoveredIndex === lastHoveredIndex ? lastHoveredIndex : i), setHoveredIndex(i))}
              onClick={() => handleClick(i)}
              ref={addItemRef}
            >
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
              {(hoveredIndex === i || activeIndex === i) && <div className={styles.hoverArrow} />}
            </div>

            {isMobile && activeIndex === i && (
              <div className={styles.extraInfo}>
                <p>{r.extra}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Desktop-only hover info box */}
      {!isMobile && 
      <div className={`${styles.hoverInfo} ${hoveredIndex !== null ? styles.visible : ''}`}>
        <p>{hoveredIndex !== null ? reasons[hoveredIndex].extra : reasons[lastHoveredIndex].extra}</p>
      </div>}
    </section>
  );
};

export default WhyChooseUs;
